// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"2":"1f01922d","123":"e959c17f","214":"ca784b3b","266":"c44e347a","294":"84eaf5ec","561":"62d5ca65","768":"b64d6bcd","782":"62afe893","973":"6b80f8cd"}[chunkId] + ".js";
};